import { reactive, computed } from 'vue'

const state = reactive({
  token: localStorage.getItem('auth_token') || null,
  user: null
})

const isAuthenticated = computed(() => !!state.token)

function setTokens(token) {
  state.token = token
  localStorage.setItem('auth_token', token)
}

function setUser(user) {
  state.user = user
}

function logout() {
  state.token = null
  state.user = null
  localStorage.removeItem('auth_token')
  window.location.href = '/giris'
}

export default {
  state,
  isAuthenticated,
  setTokens,
  setUser,
  logout
}
